import { CLEAR_DASHBOARD_SETTINGS } from './constants'
import initialState from './initialState'

export function clearDashboardSettings() {
  return async dispatch => {
    dispatch({
      type: CLEAR_DASHBOARD_SETTINGS
    })
  }
}

export function reducer(state, action) {
  if (action.type === CLEAR_DASHBOARD_SETTINGS) {
      return {
        ...state,        
        ...initialState,
        groupSelected: undefined
      }
  } else {
      return state
  }
}